import { observer } from "mobx-react-lite"
import "./about.css"
import { Button } from "antd";
import AboutTabs from "./AboutTabs";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import VideoPopupAbout from "./VideoPopupAbout";

const ClearChaos = observer(() => {
    const { t } = useTranslation();

    return (
        <div>
            <div className="head">
                <div className="upper-bg">
                    <div className="logo"></div>
                    <h1><span className="blue-text">{t("CLEAR")}</span> <span>{t("THE")}</span> <span className="rubik red-text">{t("CHAOS")}</span></h1>
                    <div className="description"><strong className="blue-text">SkTech</strong>{t(" - HR, time tracking, tasks, and salaries — all in one workspace. No spreadsheets. No mess. Just clarity.")}</div>
                     <Link to="/register-company" target="_blank"><button className="clean-mess">{t("CLEAN THAT MESS")}</button></Link>
                    <div className="see-work">{t("👉 See how it works - ")}<VideoPopupAbout /></div>   
                    
                </div>
                <div className="down-bg">
                    <AboutTabs />
                </div>
                <div className="black-hr">
                    <div>{t("✓ You manage people, not spreadsheets")}</div>
                    <div>{t("✓ Finally — an HR system that doesn’t make you cry")}</div>
                    <div>{t("✓ Smarter workflows. Happier people.")}</div>
                    <div>{t("✓ Everything your team needs, nothing they don’t")}</div>
                    <div>{t("✓ Because you’ve got better things to do than Excel")}</div>
                    <div>{t("✓ Less guessing, more doing")}</div>
                </div>
            </div>
            <div></div>
            <div></div>
        </div>
    )
})
export default ClearChaos;